import React from 'react';
import { Text } from '@good/ui/core';
import moment from 'moment';
import { ServiceAgreementHistoryModalStep } from './types';

interface ServiceAgreementHistorySubheaderProps {
  step: ServiceAgreementHistoryModalStep;
  serviceAgreementHistory: any;
}

export const ServiceAgreementHistorySubheader = ({
  step,
  serviceAgreementHistory,
}: ServiceAgreementHistorySubheaderProps) => {
  return (
    <Text c='dimmed' size='md'>
      {step === 'listing' && (
        <span>
          Each time a service agreement is edited we store a version of the Service Agreement for auditing purposes.
          View all versions of this Service Agreement below.
        </span>
      )}
      {step === 'detail' && (
        <span>
          This version of the customer service agreement was{' '}
          {serviceAgreementHistory.description === 'New Service Agreement created' ? 'created' : 'edited'} by{' '}
          <b>
            {serviceAgreementHistory.createdByFirstName} {serviceAgreementHistory.createdByLastName}
          </b>{' '}
          on {moment(serviceAgreementHistory.updatedOn).format('DD/MM/YYYY')}
        </span>
      )}
    </Text>
  );
};
